export const formatPrice = (value, currency, showSymbol = false) => {
  if (isNaN(value)) return '';

  const currencyFormats = {
    USD: { locale: 'en-US', symbol: 'USD' },
    ARS: { locale: 'es-AR', symbol: 'ARS' },
    EUR: { locale: 'de-DE', symbol: 'EUR' },
    BRL: { locale: 'pt-BR', symbol: 'BRL' },
  };

  const format = currencyFormats[currency] || currencyFormats.USD;

  const options = {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  };

  const formatter = new Intl.NumberFormat(format.locale, options);
  const formattedPrice = formatter.format(value);

  return showSymbol ? `${format.symbol} ${formattedPrice}` : formattedPrice;
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
